import React from 'react';
import { branch, renderNothing } from 'recompose';
import LeaveButton, { hideLeaveButton } from '../common/LeaveRace';
import TermsAndConditions from './TermsAndConditions';

export const Fragment = ({ children }) => <>{children}</>;
export const Div = props => <div {...props} />;

export default branch(
    ({ termsAndConditionsUrl, status, joined }) =>
        !termsAndConditionsUrl && hideLeaveButton({ status, joined }),
    renderNothing
)((props) => {
    const { termsAndConditionsUrl, className = '' } = props;
    const Container = className ? Div : Fragment;

    return (
        <Container className={className}>
            <TermsAndConditions termsAndConditionsUrl={termsAndConditionsUrl} />
            <LeaveButton {...props} />
        </Container>
    );
});
